import React, { useEffect, useState } from "react";
import { Button, Col, Dropdown, Row } from "react-bootstrap";
import api from "../../utils/ApiMethod";
import { ADMIN_LOGIN_BASE_URL } from "../../apiservices/apiService";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

const ExportNurshingStudentSession = (selectedOption: any) => {
  const [exportSessionValue, setExportSessionValue] = useState<any>();

  const sessionToExport = [
    "2024",
    "2023",
    "2022",
    "2021",
    "2020",
    "2019",
    "2018",
  ];


  useEffect(() => {
    setExportSessionValue("");
  }, [selectedOption?.selectedRows]);
  const {
    user,
    //  userLoggedIn, error, userId
  } = useSelector((state: RootState) => ({
    user: state.Auth.user,
    loading: state.Auth.loading,
    error: state.Auth.error,
    userLoggedIn: state.Auth.userLoggedIn,
    userId: state.Auth._id,
  }));
  let profileId = user._id ? user._id : user.user ? user.user._id : "";
  let Role = user.hobbies ? user.hobbies : user.user.hobbies;
  let profileName = user.name ? user.name : user.user.name;
  let subDepartmentName = user.department
    ? user.department
    : user.user.department;

  const Key_Key = user.moniterd_ttl
    ? user.moniterd_ttl
    : user.user
    ? user.user.moniterd_ttl
    : "";

  const handleExportSessionNurshing = (e: any) => {
    e.preventDefault();
    alert(
      `session is about to export fron your current session to \n Session: ${exportSessionValue}`
    );
    const course_name = "02";
    if (exportSessionValue) {
      const postData = async () => {
        try {
          const formData = new FormData();
          formData.append(
            "Selected Studnet Id for Session Export",
            selectedOption.selectedRows
          );
          const response = await api.createData(
            `/api/export/session/ug/nurshing/student/${profileId}/${Key_Key}/${exportSessionValue}/${course_name}`,
            formData
          );
          // console.log(response);
          alert("Session Exported Successfully");
          if (response.status !== 200) {
            const errorMsg = await response.json();
            alert(errorMsg?.message);
            // setIsResponse(errorMsg?.message || "Unknown error occurred.");
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          if (response.status === 440) {
            alert("Session Expired");
            // dispatch(logoutUser());
            window.location.href = `${ADMIN_LOGIN_BASE_URL}/auth/login`; // Use the full URL, including the protocol (http or https)
          }
          // console.log(response)
        } catch (error) {}
      };
      postData();
    } else {
      alert("Please Select Session befor Exporting Session, Thank you!");
    }
  };

  return (
    <div>
      <Row>
        <Col sm={4}>
          <Dropdown onSelect={(eventKey) => eventKey && setExportSessionValue(eventKey)}>
            <Dropdown.Toggle
              variant="primary"
              disabled={selectedOption.selectedOption !== "Export session"}
            >
              {exportSessionValue ? exportSessionValue : "Export to session"}
            </Dropdown.Toggle>
            <Dropdown.Menu>
            {sessionToExport &&
                sessionToExport.map((dataExport) => (
                  <Dropdown.Item eventKey={dataExport}
                    // onClick={(e) =>
                    //   setExportSessionValue(e.target.innerText)
                    // }
                  >
                    {dataExport}
                  </Dropdown.Item>
                ))}
              <Dropdown.Divider />
              <Dropdown.Item
                eventKey=""
                style={{ color: "blue", backgroundColor: "silver" }}
                onClick={() => setExportSessionValue("")}
              >
                Clear Session
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Col>
        <Col sm={8}>
          {exportSessionValue ? (
            <Button
              variant="primary"
              disabled={selectedOption.selectedOption !== "Export session"}
              onClick={(e) => handleExportSessionNurshing(e)}
            >
              Export Now
            </Button>
          ) : null}
        </Col>
      </Row>
    </div>
  );
};

export default ExportNurshingStudentSession;

